<template>
  <transition name="popup-slide" @after-leave="$emit('close')">
    <div v-if="visible" class="notification-popup">
      <div class="notification-popup__body" @click="openConversation">
        <div class="notification-list--wrap">
          <div
            v-if="!notification.read_at"
            class="notification-unread--indicator"
          />
          <div v-else class="notification-unread--indicator empty" />
          <div class="notification-content--wrap">
            <div class="title-row">
              <span class="notification-title">
                {{
                  `#${
                    notification.primary_actor
                      ? notification.primary_actor.id
                      : $t('NOTIFICATIONS_PAGE.DELETE_TITLE')
                  }`
                }}
              </span>
              <span class="notification-type">
                {{
                  $t(
                    `NOTIFICATIONS_PAGE.TYPE_LABEL.${notification.notification_type}`
                  )
                }}
              </span>
            </div>
            <span class="notification-message">
              {{ notification.push_message_title }}
            </span>
          </div>
        </div>
      </div>
      <div class="notification-popup__progress-track">
        <div
          class="notification-popup__progress-bar"
          :style="{ width: progressWidth + '%' }"
        />
      </div>
    </div>
  </transition>
</template>

<script>
import timeMixin from 'dashboard/mixins/time';
import { mapGetters } from 'vuex';

const DURATION_MS = 5000;
const TICK_MS = 50;

export default {
  mixins: [timeMixin],
  props: {
    notification: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      visible: false,
      progressWidth: 100,
    };
  },
  computed: {
    ...mapGetters({
      meta: 'notifications/getMeta',
    }),
  },
  mounted() {
    this.show();
  },
  beforeDestroy() {
    this.clearTimers();
  },
  methods: {
    show() {
      this.progressWidth = 100;
      this.visible = true;

      const steps = DURATION_MS / TICK_MS;
      const decrement = 100 / steps;

      this.progressTimer = setInterval(() => {
        this.progressWidth = Math.max(0, this.progressWidth - decrement);
      }, TICK_MS);

      this.closeTimer = setTimeout(() => {
        this.visible = false;
        this.clearTimers();
      }, DURATION_MS);
    },
    clearTimers() {
      clearInterval(this.progressTimer);
      clearTimeout(this.closeTimer);
    },
    openConversation() {
      const {
        primary_actor_id: primaryActorId,
        primary_actor_type: primaryActorType,
        primary_actor: { id: conversationId },
      } = this.notification;

      this.$store.dispatch('notifications/read', {
        primaryActorId,
        primaryActorType,
        unreadCount: this.meta.unreadCount,
      });
      this.$router.push({
        name: 'inbox_conversation',
        params: { conversation_id: conversationId },
      });
      this.visible = false;
      this.clearTimers();
    },
  },
};
</script>

<style scoped lang="scss">
.notification-popup {
  width: 320px;
  background: #ffffff;
  border: 1px solid #f1f5f8;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.notification-popup__body {
  padding: var(--space-small) var(--space-slab);
  cursor: pointer;

  &:hover {
    background: var(--b-50);
  }
}

.notification-list--wrap {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: var(--space-small);
  line-height: 1.4;
}

.notification-unread--indicator {
  flex-shrink: 0;
  margin-top: var(--space-smaller);
  width: var(--space-small);
  height: var(--space-small);
  border-radius: var(--border-radius-rounded);
  background: var(--c-500);

  &.empty {
    background: transparent;
  }
}

.notification-content--wrap {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  gap: var(--space-micro);
}

.title-row {
  display: flex;
  align-items: center;
  gap: var(--space-smaller);
  flex-wrap: wrap;
}

.notification-title {
  font-weight: var(--font-weight-black);
  font-size: var(--font-size-small);
}

.notification-type {
  font-size: var(--font-size-micro);
  padding: var(--space-micro) var(--space-smaller);
  background: var(--s-50);
  border-radius: var(--border-radius-normal);
  white-space: nowrap;
}

.notification-message {
  display: block;
  color: var(--color-body);
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-normal);
  white-space: normal;
  word-break: break-word;
}

.timestamp {
  color: var(--b-500);
  font-size: var(--font-size-micro);
  font-weight: var(--font-weight-bold);
}

.notification-popup__progress-track {
  width: 100%;
  height: 3px;
  background: #d9d9d9;
}

.notification-popup__progress-bar {
  height: 100%;
  background: #0230ff;
  transition: width 50ms linear;
}

.popup-slide-enter-active,
.popup-slide-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.popup-slide-enter,
.popup-slide-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
</style>
